'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardPaymentFormContainer = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _decorator = require('helpers/decorator');

var _Sagas = require('decorators/Sagas/Sagas');

var _AddressValidator = require('components/AddressForm/AddressValidator');

var _countriesServed = require('constants/countries-served');

var _CardPaymentForm = require('components/PaymentMethods/CardPaymentForm/CardPaymentForm');

var _CardPaymentForm2 = require('components/PaymentMethods/CardPaymentForm/CardPaymentForm.saga');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var countryShortCode = _countriesServed.COUNTRY_CODE_TO_SHORT_CODE[ownProps.countryCode];
  var addressRequirements = _bound.getAddressRequirements.data(state, countryShortCode) || {};
  var hideZip = ownProps.hideZip || (0, _verify.isEmpty)(addressRequirements) || (0, _AddressValidator.shouldHideField)(addressRequirements, 'postalCode');
  var allowPrepaidCards = !!ownProps.allowPrepaidCards;

  return {
    countryShortCode: countryShortCode,
    hideZip: hideZip,
    allowPrepaidCards: allowPrepaidCards
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadAddressRequirements: _CardPaymentForm2.loadAddressRequirements
};

var CardPaymentFormContainer = exports.CardPaymentFormContainer = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _CardPaymentForm2.watchSaga }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_CardPaymentForm.CardPaymentForm);

CardPaymentFormContainer.propTypes = {
  countryCode: _propTypes2.default.string.isRequired,
  hideZip: _propTypes2.default.bool,
  allowPrepaidCards: _propTypes2.default.bool
};